import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PulseNpsTrendComponent } from './pulse-nps-trend.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";



@NgModule({
  declarations: [PulseNpsTrendComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PulseNpsTrendComponent]
})
export class PulseNpsTrendModule { }
